import { capChangeLines } from "./changeLines";

/** What a reason is about, above its box: one line per change ("CD rate: Lag → Follow"), at most four and then "and N more changes", compared with where the year opened. */
export function GxChangeLines({ testId, lines }: { readonly testId: string; readonly lines: readonly string[] }) {
  if (lines.length === 0) return null;
  const { shown, more } = capChangeLines(lines);
  return (
    <div className="gx-decide-changes" data-testid={testId}>
      <div className="gx-lbl">You changed, since the year opened</div>
      <ul className="gx-decide-change-list">
        {shown.map((l) => <li key={l}>{l}</li>)}
        {more === null ? null : <li className="gx-muted">{more}</li>}
      </ul>
    </div>
  );
}
